import React from 'react';
import { SelectionFlatTree } from '@bingads-webui-fluent-component/selection-tree';

import { mergeClasses } from '@fluentui/react-components';
import { AggregationMode, I18n, SelectionFlatTreeProps } from '../types';
import { useTreeStyles } from './tree-styles';
import { useRenderingData } from '../hooks/use-rendering-props';

interface TreeProps {
  i18n?: I18n;
  className?: string;
  selectionMode?: SelectionFlatTreeProps['selectionMode'];
  aggregateMode?: AggregationMode;
  infiniteScroll?: boolean;
  showSelectedOnly?: boolean;
  customFilter?: (item: any, search: string) => boolean;
  onRenderItemContent?: SelectionFlatTreeProps['onRenderContent'];
}

export const Tree: React.FC<TreeProps> = ({
  i18n,
  className,
  selectionMode,
  aggregateMode,
  infiniteScroll,
  showSelectedOnly,
  customFilter,
  onRenderItemContent,
}) => {
  const classes = useTreeStyles();

  const {
    items, itemsMap, checkedItems, openItems, setOpenItems, isList, onReachEnd, onChange,
  } = useRenderingData({
    mode: aggregateMode,
    showSelectedOnly,
    customFilter,
  });

  if (!items.length) { return null; }

  return (
    <SelectionFlatTree
      i18n={i18n}
      treeClassName={mergeClasses(className, isList && classes.rootList)}
      selectionMode={selectionMode}
      treeItems={items}
      itemsMap={itemsMap}
      checkedItems={checkedItems}
      openItems={openItems}
      onChange={onChange}
      onOpenChange={setOpenItems}
      onRenderContent={onRenderItemContent}
      {...(infiniteScroll ? { onReachEnd } : {})}
    />
  );
};
